import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsVivaEngageRebranding = () => boolean;
export const useIsVivaEngageRebranding: UseIsVivaEngageRebranding = () => {
  const isVivaEngageRebranding = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebranding) === true;

  return isVivaEngageRebranding;
};
